import type { IDomainEventId } from '@app/domain/domain-events/domain-events.interface'
import type { AppAction } from '@app/state'

export interface State {
  errorMessage: string
}

export enum ActionType {
  ResubmitDomainEvent = 'DOMAIN_EVENT/RESUBMIT_DOMAIN_EVENT',
  ResubmitDomainEventFailed = 'DOMAIN_EVENT/RESUBMIT_DOMAIN_EVENT/FAILED',
  ResubmitDomainEventSucceeded = 'DOMAIN_EVENT/RESUBMIT_DOMAIN_EVENT/SUCCEEDED',
}

export type Action =
  | { type: ActionType.ResubmitDomainEvent; id: IDomainEventId }
  | {
      type: ActionType.ResubmitDomainEventFailed
      id: IDomainEventId
      errorMessage: string
    }
  | { type: ActionType.ResubmitDomainEventSucceeded; id: IDomainEventId }

export const actions = {
  resubmitDomainEvent(id: IDomainEventId): Action {
    return { type: ActionType.ResubmitDomainEvent, id }
  },
  resubmitDomainEventFailed(id: IDomainEventId, errorMessage: string): Action {
    return { type: ActionType.ResubmitDomainEventFailed, id, errorMessage }
  },
  resubmitDomainEventSucceeded(id: IDomainEventId): Action {
    return { type: ActionType.ResubmitDomainEventSucceeded, id }
  },
}

export const initialState: State = {
  errorMessage: null,
}

export function reducer(state: State = initialState, action: AppAction): State {
  switch (action.type) {
    case ActionType.ResubmitDomainEventFailed:
      return {
        ...state,
        errorMessage: action.errorMessage,
      }
    case ActionType.ResubmitDomainEventSucceeded:
      return {
        ...state,
        errorMessage: null,
      }
    default:
      return state
  }
}
